import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

interface product {
  name: string;
  productId: number;
}

@Component({
  selector: 'app-add-customer-product-price',
  templateUrl: './add-customer-product-price.component.html',
  styleUrls: ['./add-customer-product-price.component.css']
})
export class AddCustomerProductPriceComponent implements OnInit {

  addCustomerProductPriceForm: any | FormGroup;
  cid: any;
  formSubmit: boolean = false;

  productList: any = []
  products: product[] | any = [];
  selectedProduct: any;

  customerList: any = []
  customers: any = [];
  selectedCustomers: any;

  uomList: any = []
  uoms: any = [];
  selectedUOM: any;


  designationList:any = []
  designationDropdownList:any = [];
  designationSelectedList:any = [];
  designationDropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'designationInfoId',
    textField: 'designationName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };


  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService,
  ) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.addCustomerProductPriceForm = this.fb.group({
      description: [''],
      customerId: [''],
      productId: [''],
      uom: [''],
      minQty: [''],
      maxQty: [''],
      perUnitPrice: ['']
    })
    this.getAllProducts()
    this.getAllCustomerWithoutPagination()
    this.getAllUomMaster()
  }

  addCustomerProductPrice(){
    this.formSubmit = true;

    console.log(this.selectedProduct)
    console.log(this.selectedCustomers)
    console.log(this.selectedUOM)
    
    let productId = this.selectedProduct.productId
    let productName = this.selectedProduct.name
    let uom = this.selectedUOM.uomName

    for(let list of this.selectedCustomers){
      const body = {
        "version": 0,
        "isActive": true,
        "description": this.addCustomerProductPriceForm.get('description').value,
        "customerId": Number(list.customerInfoId),
        "customerName": list.name,
        "productId": Number(productId),
        "productName": productName,
        "uom": uom,
        "minQty": Number(this.addCustomerProductPriceForm.get('minQty').value),
        "maxQty": Number(this.addCustomerProductPriceForm.get('maxQty').value),
        "perUnitPrice": Number(this.addCustomerProductPriceForm.get('perUnitPrice').value),
        "cid": Number(this.cid)
      }
      console.log(body);
  
      this.generic_service.addCustomerProductPrice(body).subscribe(
        (response: any)=>{
          console.log(response);
          // this.formSubmit = false;
          // this.toastr.success(response.message);
          // this.addCustomerProductPriceForm.reset();
        },
        (error: any)=>{
          console.log(error);
          // this.toastr.error(error.message);
          // this.formSubmit = false;
        }
      )
    }
    this.formSubmit = false;
    this.toastr.success('success');
    this.addCustomerProductPriceForm.reset();
    this.selectedProduct = [];
    this.selectedCustomers = [];
    this.selectedUOM = {};

  }



  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  getAllProducts(){
    this.generic_service.getAllProducts().subscribe(
      (response:any)=>{
        console.log(response)
        this.productList = response.response;
        for(let list of response.response){
          this.products.push(
            {
              name: list.name,
              productId: list.productMasterId
            }
          )
        }
        console.log(this.products)

      }
    )
  }

  getAllCustomerWithoutPagination(){
    this.generic_service.getAllCustomerWithoutPagination().subscribe(
      (response:any)=>{
        console.log(response)
        this.customerList = response.response;
        for(let list of response.response){
          this.customers.push(
            {
              name: list.name,
              customerInfoId: list.customerInfoId
            }
          )
        }
      }
    )
  }

  getAllUomMaster(){
    this.generic_service.getAllUomMaster().subscribe(
      (response:any)=>{
        console.log(response)
        this.uomList = response.response;
        for(let list of response.response){
          this.uoms.push(
            {
              uomName: list.uomName,
              uomMasterId: list.uomMasterId
            }
          )
        }
      }
    )
  }
}